import styled from 'styled-components';

import { ColorsV2, Flex, Icon, InitialsInCircle, Text } from '@electricjs/arc';

import { OrgSelectionChoice, RoleDisplayMapping } from '@/types/users';

const ClickableRow = styled(Flex)`
  cursor: pointer;

  &:hover {
    filter: brightness(0.97);
  }
`;

const AVATAR_COLORS = [
  ColorsV2.DATA_VIZ_BLUE_DARK,
  ColorsV2.DATA_VIZ_PURPLE_DARK,
  ColorsV2.DATA_VIZ_GREEN_DARK,
  ColorsV2.DATA_VIZ_ORANGE_DARK,
  ColorsV2.DATA_VIZ_RED_DARK,
  ColorsV2.DATA_VIZ_BROWN_MEDIUM,
];

type OrgSelectorRowProps = {
  choice: OrgSelectionChoice;
  index?: number;
  onSelect: () => void;
};

export const OrgSelectorRow = ({
  choice,
  index = 0,
  onSelect,
}: OrgSelectorRowProps) => {
  const roleName = RoleDisplayMapping[choice.roles[0]?.slug]?.displayName;

  return (
    <ClickableRow
      id={`org-selector-row-${choice.id}`}
      alignItems="center"
      justifyContent="space-between"
      padding="2rem 2.4rem"
      gap="1.2rem"
      onClick={onSelect}>
      <Flex alignItems="center" gap="1.2rem">
        <InitialsInCircle
          text={choice.name ?? ''}
          size="4rem"
          borderRadius="0.5rem"
          backgroundColor={AVATAR_COLORS[index % AVATAR_COLORS.length]}
          textColor={ColorsV2.WHITE_STATIC}
        />
        <Flex vertical>
          <Text variant="body-2">
            <b>{choice.name}</b>
          </Text>
          {roleName && <Text variant="legal">{roleName}</Text>}
        </Flex>
      </Flex>
      <Icon icon="chevron-right" size="medium" />
    </ClickableRow>
  );
};

export default OrgSelectorRow;
